import { render } from "./MenuContentItemValueText.vue?vue&type=template&id=0ef3e3de"
import script from "./MenuContentItemValueText.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__